import ReactGA from "react-ga";

/**
 * 购买页面展示
 */
const GAPurchasePageDisplay = () => {
  ReactGA.event(
    {
      category: "pricing",
      action: "pricing_display",
    },
    ["OnlineTracker", "Tracker"]
  );
};

/**
 * 月套餐点击购买
 */
const GAPurchaseMonthlyClick = () => {
  ReactGA.event(
    {
      category: "pricing",
      action: "pricing_month_click",
    },
    ["OnlineTracker", "Tracker"]
  );
};

/**
 * 年套餐点击购买
 */
const GAPurchaseYearlyClick = () => {
  ReactGA.event(
    {
      category: "pricing",
      action: "pricing_year_click",
    },
    ["OnlineTracker", "Tracker"]
  );
};

/**
 * 购买弹窗去购买
 */
const GAPurchaseModalBuyClick = () => {
  ReactGA.event(
    {
      category: "premium_popup",
      action: "premium_popup_buy",
    },
    ["OnlineTracker", "Tracker"]
  );
};

export { GAPurchasePageDisplay, GAPurchaseMonthlyClick, GAPurchaseYearlyClick, GAPurchaseModalBuyClick };
